/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Loader } from "@mantine/core";
import { IconUpload } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { ReactComponent as IconError } from "src/assets/icons/toast-error.svg";
import { ReactComponent as IconSuccess } from "src/assets/icons/toast-success.svg";
import { ScreenLoader } from "src/components/screenLoader";
import { stepAndRouteMap } from "src/constants";
import { ScreenWrapper } from "../../components";
import { OnboardingProgress } from "../../components/onboardingProgress";
import { RootState } from "../../redux/store";
import { useStyles } from "./panCardVerify.styles";
import {
  clearPanDetailsFormError,
  savePanImage,
  setPanDetailsFormStatus,
} from "./panDetailsFormSlice";
import panImage from '../../assets/images/pan.png'

export const PanUpload = (): JSX.Element => {
  const { classes, cx } = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const panDetailsState = useSelector((state: RootState) => state.panDetails);
  const accountState = useSelector((state: RootState) => state.account);
  const fileRef = createRef<HTMLInputElement>();
  const isImgSaved = panDetailsState.isPanImageSaved;
  const [initialInput, setInitialInput] = useState(false);
  const [inputFiledValue, setInputFiledValue] = useState<any>(undefined);
  const { userDetails } = accountState;

  useEffect(() => {
    if (panDetailsState.status === "success" && panDetailsState.isPanImageSaved
    ) {
      notifications.show({
        color: "green",
        message: "PAN card Uploaded Successfully!",
        icon: <IconSuccess />,
      });
      const nextStepFromBackend = userDetails.nextStep;
      navigate(stepAndRouteMap[nextStepFromBackend][0]);
    } else if (panDetailsState.status === "error") {
      dispatch(clearPanDetailsFormError());
      notifications.show({
        color: "red",
        message:
          panDetailsState.error.message
          || "PAN image upload failed, Try again!",
        icon: <IconError />,
      });
    }
  }, [panDetailsState.status]);

  const panUploadLabel = (): string | JSX.Element => {
    if (panDetailsState.status === "loading") {
      return (
        <>
          <p>Uploading</p>
          <Loader size="sm" variant="dots" color="pink" />
        </>
      );
    }
    return isImgSaved ? (
      `Uploaded`
    ) : (
      <>
        <IconUpload size={16} stroke={2} />
        <p>{initialInput ? "Re upload PAN Image" : "Upload PAN image"}</p>
      </>
    );
  };

  const uploadImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setInitialInput(true);
    if (!e.target.files || !e.target.files[0]) {
      return;
    }
    const file = e.target.files[0];
    if (file) {
      dispatch(savePanImage({ panCardImage: file }));
    } else {
      notifications.show({
        color: "red",
        message:
          "Unable to read PAN Image, Please make sure that your PAN Image is clear",
        icon: <IconError />,
      });
    }
    setInputFiledValue("");
  };

  return (
    <ScreenWrapper>
      <div className="csMainContainer">
        <div className="csHeader">
          <div className="csProgressWrapper">
            <OnboardingProgress progress={8.25} />
          </div>
        </div>
        <div className={classes.contentContainer}>
          <div>
            <h2 className="csHeading">PAN</h2>
            <p className="csDescription">Please upload your pan card image</p>
            <div className={classes.aadharImgWrapper}>
              <img className={classes.aadharImg} src={panImage} alt="" />
            </div>
          </div>
        </div>
        <div className="csFooter">
          <div className={classes.popularBankList}>
            <label htmlFor="pan-image-input" className={cx(classes.fileLabel)}>
              {panUploadLabel()}
              <input
                type="file"
                name="pan-image-input"
                id="pan-image-input"
                accept="image/*"
                className={classes.fileInput}
                onChange={uploadImage}
                ref={fileRef}
                value={inputFiledValue}
                disabled={panDetailsState.status === "loading"}
              />
            </label>
          </div>
        </div>
      </div>
      {panDetailsState.status === "loading" ? <ScreenLoader /> : null}
    </ScreenWrapper>
  );
};

export default PanUpload;
